import { Card, Row } from "antd";
import { Filter } from "./Filter";
import { useState } from "react";
import { ItemList } from "./ItemList";

type ListViewProps = {
  contractGeneralData: any;
  years: number[];
  year: number | undefined;
  setYear: React.Dispatch<React.SetStateAction<number | undefined>>;
  paymentHistory: any[];
  isLoadingYears: boolean;
  isLoadingPaymentHistory: boolean;
  setPaymentRecord: React.Dispatch<React.SetStateAction<any>>;
  setPage: React.Dispatch<React.SetStateAction<string>>;
};

export const ListView = ({
  contractGeneralData,
  years,
  year,
  setYear,
  paymentHistory,
  isLoadingYears,
  isLoadingPaymentHistory,
  setPaymentRecord,
  setPage,
}: ListViewProps) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Row className="justify-center w-100 py-2 overflow-y-hidden">
      <Card className="ph-card-container mx-4 h-100 overflow-y-auto">
        <Row className="disclamer-description">
          <div>
            <p className="mt-0 mb-2 text-sm title">
              This balance and/or transaction history is provided for
              information purposes only and should not be used for payoff
              purposes.
              {!expanded && (
                <span
                  className="show-more ml-1"
                  onClick={() => setExpanded(!expanded)}
                >
                  Show more
                </span>
              )}
            </p>
            {expanded && (
              <p className="mt-0 mb-4 text-sm title">
                Please be advised that it may take up to 24 hours to process the
                transaction. All payments will be posted as of the payment
                effective date and not the payment initiation date.
                <span
                  className="show-less ml-1"
                  onClick={() => setExpanded(!expanded)}
                >
                  Show less
                </span>
              </p>
            )}
          </div>
        </Row>
        <Filter
          contractGeneralData={contractGeneralData}
          years={years}
          value={year}
          isLoading={isLoadingYears}
          setYear={setYear}
        />
        <ItemList
          items={paymentHistory || []}
          isLoading={isLoadingPaymentHistory || isLoadingYears}
          setPaymentRecord={setPaymentRecord}
          setPage={setPage}
        />
      </Card>
    </Row>
  );
};
